exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group .btn__content{min-width:130px!important}.tab-btn-container{display:flex;flex-direction:row;background:#eee;border-radius:8px}.import-export-btn{width:50%;text-align:center;padding:6px}.tab-btn{height:32px;display:flex;justify-content:center;align-items:center;border-radius:8px;cursor:pointer;user-select:none;transition:all .3s}.active-tab-btn,.response-div{background-color:#006b8d;color:#fff}.response-div{font-size:20px;font-weight:500;display:inline;padding:6px 8px;border-radius:4px}.inch-div{font-style:italic;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38488683","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/checkRate.vue
// module id = 799
// module chunks = 0